import styled from "styled-components";
import { Link } from "react-router-dom";

import { breakpoint } from "@utilities";

interface IProps {
    data: {
        title: string;
        link: string;
        onClick?: () => void;
    }[];
}

export const BreadcrumbsCommon = (props: IProps) => {
    const { data } = props;
    return (
        <StyledContainer>
            {data.map((item, index) => {
                const handleClick = (e: React.MouseEvent) => {
                    if (item.onClick) {
                        e.preventDefault();
                        item.onClick();
                    }
                };

                return index !== data.length - 1 ? (
                    <StyledLink
                        to={item.link}
                        className="breadcrumbsItem"
                        key={index}
                        onClick={handleClick}
                    >
                        <span>{item.title}</span>
                        <img src="/images/fi_chevron-right.png" alt="" />
                    </StyledLink>
                ) : (
                    <StyledLink
                        to={item.link}
                        className="breadcrumbsItem"
                        key={index}
                        onClick={handleClick}
                    >
                        <span className="active">{item.title}</span>
                    </StyledLink>
                );
            })}
        </StyledContainer>
    );
};

const StyledContainer = styled.div`
    display: flex;
    align-items: center;
    font-family: "Poppins", sans-serif;
`;

const StyledLink = styled(Link)`
    display: flex;
    align-items: center;
    font-size: 12px;
    font-weight: 700;
    line-height: 22px;
    color: ${(props) => props.theme.colors.black};
    span {
        font-size: 1rem;
    }

    ${breakpoint.breakIpadPro`
        font-size: 14px;
    `}

    img {
        margin: 0 12px;
    }

    /* A literal rather than a token: no existing grey matches, and the nearest
       (gray_3, #828282) is a different shade. */
    .active {
        color: #747474;
    }
`;
